import { Flex, Typography } from "antd";
import { useMemo } from "react";
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { datetime } from "../../../../util/library/datetime";
import { EXECUTION_TYPE, OP_RUNNING_MODE, STEP_KEY_V2 } from "../../../../util/varibles/constants";
import { IActivityLog, IHarvest2 } from "../../../../util/varibles/interface";
import { ChecklistsSection } from "../ChecklistsForm";
import FinishStepButton from "../FinishStepButton";

interface CompletedProps {
    log: IActivityLog
    start: IActivityLog
    prev: IActivityLog
    stepIndex: number
    harvestingSteps: NonNullable<IActivityLog["real_sub_steps"]>
    dischargingSteps: NonNullable<IActivityLog["real_sub_steps"]>
}

export default function Completed({ log, start, prev, stepIndex, harvestingSteps, dischargingSteps }: CompletedProps) {
    const [op] = useTrackingOp(state => state.op?.operation as IHarvest2);
    const { checklists_v2 = [], dead_fish, execution_type, op_running_mode = OP_RUNNING_MODE.NORMAL } = op || {};
    const { arrive_time, real_start_time: real_arrive_time } = start || {};
    const { depature_time, real_start_time: real_departure_time } = log;

    const isDone = useMemo(() => {
        if (execution_type === EXECUTION_TYPE.AUTO)
            return true;

        if (prev.key === STEP_KEY_V2.CLEANING)
            return !!prev.real_start_time;

        if (op_running_mode !== OP_RUNNING_MODE.DETAIL)
            return !!prev.real_finish_time;

        const remainingFishByTank = harvestingSteps.reduce((result: Record<string, number>, item) => {
            result[item.tank_id] = (result[item.tank_id] || 0) + (item.fish_amount || 0);
            return result;
        }, {});

        dischargingSteps.forEach(item => {
            if (!item.real_finish_time)
                return;

            remainingFishByTank[item.tank_id] = Math.max(
                0,
                (remainingFishByTank[item.tank_id] || 0) - (item.fish_amount || 0) - (item.dead_fish || 0)
            );
        });

        const tankIds = Object.keys(remainingFishByTank);
        return tankIds.length > 0 && tankIds.every(tankId => remainingFishByTank[tankId] <= 0);
    }, [dischargingSteps, execution_type, harvestingSteps, op_running_mode, prev.key, prev.real_finish_time, prev.real_start_time])

    return <div className="w-full">
        <Flex gap={6}>
            <Typography.Text type="secondary">Arrived at site: </Typography.Text>
            <Typography.Text>{(arrive_time || real_arrive_time) ? datetime(arrive_time || real_arrive_time).format("HH:mm. DD/MM") : '--'}</Typography.Text>
        </Flex>
        <Flex gap={6}>
            <Typography.Text type="secondary">Departure:</Typography.Text>
            <Typography.Text>{(depature_time || real_departure_time) ? datetime(depature_time || real_departure_time).format("HH:mm. DD/MM") : '--'}</Typography.Text>
        </Flex>
        <Flex gap={6}>
            <Typography.Text type="secondary">∑ dead fish in whole treatment:</Typography.Text>
            <Typography.Text>{dead_fish ? dead_fish : '--'}</Typography.Text>
        </Flex>

        <ChecklistsSection data={checklists_v2} />

        {isDone && <FinishStepButton name="Completed" payload={{ movement_type: "complete", current_process: stepIndex }} />}
    </div>
}
